<template>
  <div style="padding:20px">
    <content class="content has-text-centered">
      <span v-if="error">
        <b>{{ error }}</b>
        <br />
        <br />
      </span>

      {{ $t(`description.${status}`) }}
    </content>
  </div>
</template>
<script>
import { REFRESH_USER } from '../../store/actions.type'
export default {
  data () {
    return {
      status: null,
      error: null
    }
  },
  mounted () {
    const status = this.$route.query.status
    const error = this.$route.query.error

    if (status === 'paymentSuccess') {
      this.$store.dispatch(REFRESH_USER)

      let message = ''
      if (error) {
        message = `${error}<br><br>`
      }
      const statusMessage = this.$t(`description.${status}`)
      message = `${message}${statusMessage}`

      this.$buefy.dialog.confirm({
        message,
        confirmText: this.$t('button.ok'),
        canCancel: false,
        onConfirm: () => {
          window.top.location = '/'
        }
      })
    }
  }
}
</script>
